import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { ALL_NAME } from '~/components/Navigation/BlogNavigation'
import Link from '~/components/UI/Link'

import { useStyle } from '~/providers/StyleProvider'

import { queryParamToArrayParams } from '~/data/blog-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export enum ButtonType {
  Dot = 'dot',
  Inline = 'inline',
}

export interface ButtonProps {
  className?: string
  checked?: boolean
  type?: ButtonType
  children?: JSX.Element | JSX.Element[] | string
  name?: string
}

function Button({ className, checked, children, type, name }: ButtonProps) {
  const { pathname, query } = useRouter()

  const getCategoriesQuery = useCallback(() => {
    const processedCategories = queryParamToArrayParams(query?.categories ?? [])
    const index = processedCategories.indexOf(name)
    const proccessedActive = index >= 0

    proccessedActive
      ? processedCategories.splice(index, 1)
      : processedCategories.push(name)

    return processedCategories?.length > 0 && name !== ALL_NAME
      ? processedCategories
      : []
  }, [query?.categories, name])

  const [active, setActive] = useState(checked ?? false)
  const [categories, setCategories] = useState(getCategoriesQuery())

  const buttonStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  useEffect(() => {
    setCategories(getCategoriesQuery())
  }, [query?.categories, getCategoriesQuery])

  useEffect(() => {
    setActive(
      name === ALL_NAME
        ? Boolean(!query?.categories)
        : !categories.includes(name),
    )
  }, [query?.categories, categories, name])

  return (
    <Link
      className={cx(css.Button, className, buttonStyle, css?.[type], {
        active,
        disabled: name === ALL_NAME && active,
      })}
      href={{
        pathname,
        query: {
          ...query,
          categories: categories?.length > 0 ? [name] : [],
        },
      }}
      shallow={true}>
      {children}
    </Link>
  )
}

Button.defaultProps = {
  type: ButtonType.Inline,
}

export default Button
